var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        {
          attrs: { required: _vm.required },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [_vm._v(_vm._s(_vm.codeEnum.code))]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: _vm.gutter } },
            [
              _c(
                "el-col",
                { staticClass: "col_positon", attrs: { span: _vm.span1 } },
                [
                  _c(
                    "el-form-item",
                    {
                      ref: "elFormItem",
                      attrs: { prop: _vm.prop, rules: _vm.rules },
                      scopedSlots: _vm._u([
                        {
                          key: "error",
                          fn: function (ref) {
                            var error = ref.error
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: error,
                                    placement: "bottom",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "el-form-item__error" },
                                    [_vm._v(_vm._s(error))]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("el-input", {
                        directives: [
                          {
                            name: "input",
                            rawName: "v-input.num_alp",
                            modifiers: { num_alp: true },
                          },
                        ],
                        staticClass: "left_input",
                        class: [_vm.showList ? "multiple" : ""],
                        attrs: {
                          maxlength: "3",
                          disabled: _vm.showList || _vm.localDisabled,
                        },
                        on: {
                          input: _vm.handleLocalInputVal,
                          blur: _vm.handleBlur,
                        },
                        model: {
                          value: _vm.localInputVal,
                          callback: function ($$v) {
                            _vm.localInputVal = $$v
                          },
                          expression: "localInputVal",
                        },
                      }),
                      !_vm.localDisabled
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "more_box flex_center flex_center_align",
                              on: { click: _vm.selectDep },
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "select" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.span2 } },
                [
                  _c("el-input", {
                    staticClass: "right_input",
                    class: [_vm.showList ? "multiple" : ""],
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.localInputName,
                      callback: function ($$v) {
                        _vm.localInputName = $$v
                      },
                      expression: "localInputName",
                    },
                  }),
                  _c(
                    "el-popover",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showList,
                          expression: "showList",
                        },
                      ],
                      attrs: { placement: "bottom", trigger: "click" },
                    },
                    [
                      _c(
                        "el-table",
                        { attrs: { data: _vm.list, border: "", stripe: "" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              width: "105",
                              "header-align": "center",
                              align: "center",
                              property: "itmdtlcd",
                              label: "商品明細ＣＤ",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              width: "180",
                              property: "itmdtlnm",
                              "header-align": "center",
                              align: "center",
                              label: "商品明細名",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "more_box flex_center flex_center_align more_change_box",
                          attrs: { slot: "reference" },
                          slot: "reference",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "inner_box flex_center flex_center_align",
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "sel" },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("MitmdtlpDialogNew", {
        ref: "dialog",
        attrs: {
          visible: _vm.dialogVisible,
          title: _vm.dialogTitle,
          "code-field": _vm.codeField,
          "name-field": _vm.nameField,
          goodslists: _vm.goodslists,
          "multi-select": _vm.multiSelect,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          "get-selection": _vm.getSelection,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }